import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#ff5400",
    },
    secondary: {
      main: "#0a2748",
    },
  },
});
